import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { ExportOrderKey } from "../../models/domains/pbm/exports/export-order-key";
import { BackendUrl } from "../../models/domains/urls/back-end.url";

export interface IParamsGeneralReport {
  startAt: string;
  endAt: string;
  fiscalNumbers: Array<{ value: string }>;
}

@Injectable()
export class GeneralReportRepository {
  constructor(private remoteGatewayFactory: RemoteGatewayFactory) {}

  async generalReportExportOrderKey(params: IParamsGeneralReport): Promise<ExportOrderKey> {
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const backEndUrl = new BackendUrl("/api/network/general-report");

      const data: any = await remoteGateway.postWithHeaders(backEndUrl, params, headers);
      const exportOrderKey = new ExportOrderKey(data.toString());
      return exportOrderKey;
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
